import { Navigate } from 'react-router-dom'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

/**
 * Gate for the reporting prototype, driven by the shared feature flag service
 * (backend key `enable_advanced_reporting`, auto-mapped to `enableAdvancedReporting`).
 *
 * Off by default, so every `/reporting*` route redirects to /dashboard for
 * anyone whose flag isn't enabled. While flags are still loading we render
 * nothing rather than redirect, so an opted-in user doesn't bounce to /dashboard
 * on the first frame.
 */
export function ReportingPrototypeGate({
  children,
}: {
  children: React.ReactNode
}) {
  const { enableAdvancedReporting, isLoading } = useFeatureFlagService()
  if (isLoading) return null
  if (!enableAdvancedReporting) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
